import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { inject } from 'aurelia-framework';
import ConfigurationSearchVM from "./ConfigurationSearchVM";
import ConfigurationRequest from "../../Scripts/AppServiceContract/ConfigurationRequest";
import ConfigurationData from "../../Scripts/AppServiceContract/ConfigurationData";
import ConfigurationAppService from "../../Scripts/AppServiceContract/ConfigurationAppService";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";


@inject(DialogService)
export default class ConfigurationEditorVM extends EditorVMBase {
    public ConfigurationItemCode: string;
    public ConfigurationItemValue: string;
    public ConfigurationItemName: string;
    public searchVM: ConfigurationSearchVM;
    constructor() {
        super();
    }

    LoadOriginalSource(originallSource: ConfigurationData) {
        this.ConfigurationItemCode = originallSource.ConfigurationItemCode;
        this.ConfigurationItemValue = originallSource.ConfigurationItemValue;
        this.ConfigurationItemName = originallSource.ConfigurationItemName;      

    }

    SaveOriginalSource(originallSource: ConfigurationData) {
        originallSource.ConfigurationItemCode = this.ConfigurationItemCode;
        originallSource.ConfigurationItemValue = this.ConfigurationItemValue;
        originallSource.ConfigurationItemName = this.ConfigurationItemName;
    }

    CreateRequest(): ConfigurationRequest {
        var request = new ConfigurationRequest();
        request.ConfigurationItemValue = this.ConfigurationItemValue;
        request.ConfigurationItemCode = this.ConfigurationItemCode;
        request.ConfigurationItemName = this.ConfigurationItemName;
        return request;
    }

    Save(doneCallback: () => void, failCallback: (error: any) => void) {
        var self = this;
        var request = this.CreateRequest();
        var service = (this.container.get(ConfigurationAppService) as ConfigurationAppService);
        if (this.HasOriginalSource) {
            service.Update(request).done(function (Code) {
                FsUtility.AlertModal("The item has been edit successfully", 2, 1);
                doneCallback();
            }).fail(function (error) {
                FsUtility.CommonErrorHandler(error);
            });
        }
    }
}
